var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53 1.79445L10.205 2.46945C10.6 2.85945 10.6 3.49445 10.205 3.88445L3.59 10.4995H1.5V8.40945L6.7 3.20445L8.115 1.79445C8.505 1.40445 9.14 1.40445 9.53 1.79445ZM2.5 9.49945L3.205 9.52945L8.115 4.61445L7.41 3.90945L2.5 8.81945V9.49945Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.74bd2de95536d88914a2a95009833e56.svg";
export { ForwardRef as ReactComponent };